export default __webpack_public_path__ + "static/media/mdfe.d4d72119.png";